import type { BaseButtonRootProps } from '#src/base/button/base_button.tsx';
import { BaseButton } from '#src/base/button/base_button.tsx';

type AnchorTagProps = React.ComponentProps<'a'>;
type ButtonPropsRelevantToAnchors = Pick<BaseButtonRootProps, 'variant' | 'size'>;
export type AnchorAsButtonProps = AnchorTagProps & ButtonPropsRelevantToAnchors;

export const AnchorAsButton = ({
  children,
  className,
  variant,
  size,
  ...props
}: AnchorAsButtonProps) => {
  return (
    <BaseButton.Root variant={variant} size={size} loading={false} asChild>
      <a {...props}>
        <BaseButton.Content className={className} variant={variant} size={size} loading={false}>
          {children}
        </BaseButton.Content>
      </a>
    </BaseButton.Root>
  );
};
